module.exports = __webpack_public_path__ + "static/android-chrome-192x192-45bcdc2e8953f17fa2c76f1ed0335114.png";